import { OBJECTIVETASKLINK_SUCCESS, OBJECTIVETASKLINK_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const objectiveTaskLinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case OBJECTIVETASKLINK_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case OBJECTIVETASKLINK_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default objectiveTaskLinkReducer;
